import importerReducers from 'modules/shared/importer/importerReducers';
import actions from 'modules/bot/importer/botImporterActions';

export default importerReducers(actions);
